import * as DEMO from 'constants/demo'
import * as ENVIRONMENTS from 'constants/environments'

/**
 * Get the appropriate cell images API route based on environment
 * Demo environment uses a different API route than production
 */
export function getCellImagesAPIRoute(environment: string | undefined): string {
  if (environment === ENVIRONMENTS.EXTERNAL_DEMO) {
    return DEMO.DEMO_CELL_IMAGE_API_ROUTE
  }
  return DEMO.PROD_CELL_IMAGE_API_ROUTE
}

/**
 * Get the appropriate batch URL API route based on environment
 * Demo environment uses a different API route than production
 */
export function getBatchURLAPIRoute(environment: string | undefined): string {
  if (environment === ENVIRONMENTS.EXTERNAL_DEMO) {
    return DEMO.DEMO_BATCH_URL_API_ROUTE
  }
  return DEMO.PROD_BATCH_URL_API_ROUTE
}
